<style lang="less">
    .page_con.play{
        height:100vh;
        overflow: hidden;
        display: flex;
        flex-direction: column;

    }
    .art_content{
        width:100%;
        overflow: hidden;
        position: relative;
        flex:1;
        // padding:.6rem 0 0;
        // display: flex;
        // flex-direction: column;
        // align-items: center;
        // justify-content: center;
        .pd{
            width:100%;
            // flex:1;
            margin-top:.6rem;
            padding: 0 .2rem;
        }
        .art_bottom{
            width:100%;
            height:auto;
            position: absolute;
            left: 0;
            bottom: 0;
            z-index: 2;
            img.art_bottom_bg{
                width:100%;
                height:auto;
                display: block;
            }
            img.art_bottom_flowers{
                width:1.2rem;
                height:auto;
                display: block;
                position: absolute;
                left: .3rem;
                bottom:0;
                z-index: 11;
            }
            img.art_bottom_sunflowers{
                width:1.8rem;
                height:auto;
                display: block;
                position: absolute;
                right: 0rem;
                bottom:.1rem;
                z-index: 11;
            }
        }
    }
    .play_title{
        width:100%;
        height:1.3rem;
        padding:0 .4rem;
        font-size: .46rem;
        color:#fff;
        position: absolute;
        left:0;
        top:0;
        z-index: 11;
        display: flex;
        align-items: center;
        justify-content: space-around;
        >div{
            width:1.9rem;
            height:1rem;
            background:url("../assets/images/button2language-phone.png") no-repeat;
            background-size: 100% 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            span{
                margin-bottom: .1rem;
                font-size: .36rem;
            }
        }
        >div.active{
            background-image:url("../assets/images/button1language-phone.png");
        }
    }
    .art_bottom{
        width:100%;
        height:auto;
        position: absolute;
        left: 0;
        bottom: 0;
        z-index: 2;
        img.art_bottom_bg{
            width:100%;
            height:auto;
            display: block;
        }
        img.art_bottom_flowers{
            width:1.2rem;
            height:auto;
            display: block;
            position: absolute;
            left: .3rem;
            bottom:0;
            z-index: 11;
        }
        img.art_bottom_sunflowers{
            width:1.8rem;
            height:auto;
            display: block;
            position: absolute;
            right: 0rem;
            bottom:.1rem;
            z-index: 11;
        }
    }
</style>
<template>
    <div class="page_con play">
        <div class="all_top">
            <div class="btnBack" @click="$router.go(-1)"></div>
            <div class="btnHome" @click="$router.push('/index')"></div>
        </div>
        <div class="art_content">
            <div class="play_title">

                <template v-for="(item,index) in alldata.all">
                    <div :key="index" :class="{active:gameActive == item.game_type}" :d="item.game">
                        <span>{{gameTypeCn[item.game_type]}}</span>
                    </div>
                </template>
            </div>
            <div v-if="!finished">
                <write @next="next" v-if="gameActive == '6' && gameData" :date="redo_date" :game_id="alldata.all[gameId].game_id" :gameData="gameData" :push_id="alldata.info.push_id"></write>

                <fill @next="next" v-if="gameActive == '4' && gameData" :date="redo_date" :game_id="alldata.all[gameId].game_id" :gameData="gameData" :push_id="alldata.info.push_id"></fill>

                <answer @next="next" v-if="gameActive == '5' && gameData" :date="redo_date" :game_id="alldata.all[gameId].game_id" :gameData="gameData" :push_id="alldata.info.push_id"></answer>

                <discern @next="next" v-if="gameActive == '2' && gameData" :date="redo_date" :game_id="alldata.all[gameId].game_id" :gameData="gameData" :push_id="alldata.info.push_id"></discern>

                <find @next="next" v-if="gameActive == '3' && gameData" :date="redo_date" :game_id="alldata.all[gameId].game_id" :gameData="gameData" :push_id="alldata.info.push_id"></find>
                
                <contrast @next="next" v-if="gameActive == '1' && gameData" :date="redo_date" :game_id="alldata.all[gameId].game_id" :gameData="gameData" :push_id="alldata.info.push_id"></contrast>
            </div>
            <div v-else>
                <span>今天的游戏做完啦</span>
            </div>
        </div>
        <div class="art_bottom">
            <img class="art_bottom_bg" src="../assets/images/bg3-phone.png" alt="">
            <img class="art_bottom_flowers" src="../assets/images/flowers.gif" alt="">
            <img class="art_bottom_sunflowers" src="../assets/images/sunflower.gif" alt="">
        </div>
    </div>
</template>
<script>
import write from './game-write'
import fill from './game-fill'
import answer from './game-answer'
import discern from './game-discern'
import find from './game-find'
import contrast from './game-contrast'
export default {
    components:{
        write,
        fill,
        answer,
        discern,
        find,
        contrast,
    },
    data(){
        return {
            gameTypeEn:['contrast','discern','find','answer','fill','write'],
            gameTypeCn:['','對一對','認一認','找一找','填一填','答一答','寫一寫'],
            // games:['write','fill','answer'],       //discern  write  find  fill  answer  contrast
            gameActive:'',
            gameData:'',    //游戏数据
            gameId:'0',     //今天的第几个游戏
            finished:false,     //是否做完
            alldata:{
                all:[],
            },
            redo_date:'',       //重做时间
        }
    },
    mounted(){
        let date = this.$route.query.pushdate;
        this.redo_date = date;
        let read = this.$route.query.read; //this.$route.query.read;
        if(read){
            this.$router.push({path:'/artical',query:{pushdate:date?date:''}});
            return;
        }
        this.getData('',date);
    },
    methods:{
        getData(type,date){
            let vm = this;
            let url = this.baseUrl+'/Game/index.html?rest_key=1' + (date?'&pushdate='+date:'');
            if(type){
                url += ('&type='+type);
            }
            this.$http.get(url).then(res=>{
                console.log(res.data)
                if(res.data.code == 1){
                    vm.alldata = res.data.data;
                    if(type){
                        vm.gameActive = type;
                    }else{
                        vm.gameActive = res.data.data.all[0].game_type;
                    }
                    
                    let gameData = res.data.data.game.game_content;
                    let opts=[];
                    let question = '';
                    switch(vm.gameActive){
                        case '1':   //对一对
                            question = res.data.data.game.game_content.BzWord;
                            opts=[res.data.data.game.game_content.BzStructure];
                            break;
                        case '2':   //認一認
                            var options = res.data.data.btImg;
                            var len=Object.keys(res.data.data.btImg).length/2;
                            for(var i=1;i<=len;i++){
                                var answer = options['slt_'+i];
                                var right = res.data.data.game.game_content.BtYes;
                                let obj = {
                                    text:answer,
                                    id:options['slt_'+i+'_alt'],
                                    isRight:false
                                };
                                if(answer == right){
                                    obj.isRight = true;
                                }
                                opts.push(obj);
                            } 
                            break;
                        case '3':   //找一找
                            question = {ask:gameData.ZyzDefect,answer:gameData.ZyzImg};
                            var options = res.data.data.zyzImg;
                            var len=Object.keys(res.data.data.zyzImg).length/2;
                            for(var i=1;i<=len;i++){
                                var answer = options['slt_'+i];
                                var right = gameData.ZyzYes;
                                let obj = {
                                    text:answer,
                                    id:options['slt_'+i+'_alt'],
                                    isRight:false
                                };
                                if(answer == right){
                                    obj.isRight = true;
                                }
                                opts.push(obj);
                            }
                            break;
                        case '4':   //填一填
                            question = gameData.TytSentence;
                            var right = gameData.TytWord;
                            var options = res.data.data.tytWord;
                            var len=Object.keys(res.data.data.tytWord).length/2;
                            for(var i=1;i<=len;i++){
                                let answer = options['slt_'+i];
                                let obj = {
                                    text:answer,
                                    id:options['slt_'+i+'_title'],
                                    isRight:false,
                                };
                                if(answer == right){
                                    obj.isRight = true;
                                }
                                opts.push(obj);
                            }
                            break;
                        case '5':   //答一答
                            question = gameData.TytSentence;
                            var right = gameData.TytWord;
                            var options = res.data.data.tytWord;
                            var len=Object.keys(res.data.data.tytWord).length/2;
                            var colors = ['','yellow','red','green','blue'];
                            for(var i=1;i<=len;i++){
                                let answer = options['slt_'+i];
                                let obj = {
                                    text:answer,
                                    id:options['slt_'+i+'_title'],
                                    color:colors[i],
                                    isRight:false
                                };
                                if(answer == right){
                                    obj.isRight = true;
                                }
                                opts.push(obj);
                            }
                            break;
                        case '6':   //寫一寫
                            question = gameData.txtWord;
                            opts = JSON.parse(gameData.txtData);
                            opts.data = opts.data.map(v=>{
                                v.is_right = false;
                                return v
                            })
                            console.log(opts);
                            break;
                    }
                    vm.gameData = {
                        question:question,
                        opts:opts,
                    }
                    console.log('数据更新',vm.gameData);
                }
            }).catch(err=>{
            });
        },
        next(){
            let vm = this;
            let arr = this.alldata.all;
            let index;
            arr.forEach((v,i)=>{
                if(v.game_type == vm.gameActive){
                    index = i+1;
                }
            });
            this.gameId = index;
            // let index = Number(this.gameId);
            console.log(index)
            if(index < this.alldata.all.length){
                this.playGame(this.alldata.all[index]);
            }else{
                console.log('今天的题目答完了');
                // this.finished = true;
                this.$router.push('/score')
            }
        },
        playGame(item){
            this.gameActive = item.game_type;
            console.log(item);
            // this.gameId = item.game_id;
            this.gameData = '';
            this.getData(item.game_type,this.redo_date);
        },
    }
}
</script>


// WEBPACK FOOTER //
// src/components/play.vue